export default function RelationshipBadge({ type, large }) {
  const label = type
    ? type.charAt(0).toUpperCase() + type.slice(1)
    : "Other";
  return (
    <span className={`rel-badge ${type || "other"} ${large ? "large" : ""}`}>
      {label}
    </span>
  );
}
